module.exports = __webpack_public_path__ + "img/地图_map-road-two-2.86b0e12c.svg";